export default "__VITE_ASSET__B12xhN8W__"